import { WorkSpace } from "@/core/entities/workspace";

/**
 * This is a singleton class that stores the workspace object.
 * @example
 * const workSpaceContext = WorkSpaceContext.getInstance();
 * workSpaceContext.setWorkSpace(workSpace);
 * const workSpace = workSpaceContext.getWorkSpace();
 * OR
 * WorkSpaceContext.getInstance().getWorkSpace();
 */
export class WorkSpaceContext {
  private static instance: WorkSpaceContext;
  private workSpace?: WorkSpace;

  private constructor() {}

  static getInstance(): WorkSpaceContext {
    if (!WorkSpaceContext.instance) {
      WorkSpaceContext.instance = new WorkSpaceContext();
    }
    return WorkSpaceContext.instance;
  }

  setWorkSpace(workSpace: WorkSpace | null) {
    if (workSpace) {
      this.workSpace = workSpace;
    } else {
      this.workSpace = undefined;
    }
  }

  getWorkSpace(): WorkSpace | undefined {
    return this.workSpace;
  }
}
